import { forwardRef, useState } from 'react';
import { AText, Box, Button } from '@alf/uikit';
import { LazyResponsiveImage } from '@namespace/common';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { CasinoSkelet } from '../../../CasinoSkelet';
import { IAnotherCasinoTypeItemProps } from './types';

import styles from './index.module.css';

export const AnotherCasinoTypeItem = forwardRef<
  HTMLDivElement,
  IAnotherCasinoTypeItemProps
>(({ category, colorList, onClick }, ref) => {
  const [isImageLoadingEnded, setIsImageLoadingEnded] = useState(false);

  const { t } = useI18n();
  const { isDesktop }: { isDesktop?: boolean } = useDeviceStore();
  const { logo, nameTranslationKey, id, title } = category;

  return (
    <Box ref={ref} className={styles.wrapper} onClick={onClick}>
      {isDesktop && (
        <Box className={styles.hoverBlock}>
          <Button className={styles.playButton} actionType="color2" size="l">
            <AText breed="BU" size="m" className={styles.hoverText}>
              {t('web.games.widget.livegames.play')}
            </AText>
          </Button>
        </Box>
      )}

      <AText
        breed="BU"
        size="xl"
        color={colorList?.[id] || ''}
        className={styles.title}
      >
        {t(nameTranslationKey || title)}
      </AText>
      <LazyResponsiveImage
        onLoad={() => setIsImageLoadingEnded(true)}
        onError={() => setIsImageLoadingEnded(false)}
        className={styles.lazyLoadImg}
        src={logo}
        srcSetUnitsType="x"
        alt={id}
        width="100%"
        height="100%"
      />
      <CasinoSkelet isImageLoadingEnded={isImageLoadingEnded} />
    </Box>
  );
});
